import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { loadTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var BusinessMaintenanceComponent = /** @class */ (function () {
    function BusinessMaintenanceComponent(_toggleService, _editMaintenanceCheckboxDialog, snackBar, _businessManagerService) {
        this._toggleService = _toggleService;
        this._editMaintenanceCheckboxDialog = _editMaintenanceCheckboxDialog;
        this.snackBar = snackBar;
        this._businessManagerService = _businessManagerService;
        this._interiorTags = [];
        this._exteriorTags = [];
        this._airframeTags = [];
        this._airframeManufacturerTags = [];
        this._powerplantTags = [];
        this._powerplantManufacturerTags = [];
        this._propellerTags = [];
        this._propellerManufacturerTags = [];
        this._avionicsTags = [];
        this._avionicsManufacturerTags = [];
        this.editModeSet = false;
        this.isRegionalManager = false;
    }
    BusinessMaintenanceComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loadAllTags();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) { return _this.editModeSet = isOn; });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 1:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_c.sent());
                        _c.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "hasContent", {
        get: function () {
            return (this._interiorTags.length > 0 || this._exteriorTags.length > 0 ||
                this._airframeTags.length > 0 || this._airframeManufacturerTags.length > 0 ||
                this._powerplantTags.length > 0 || this._powerplantManufacturerTags.length > 0 ||
                this._propellerTags.length > 0 || this._propellerManufacturerTags.length > 0 ||
                this._avionicsTags.length > 0 || this._avionicsManufacturerTags.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    BusinessMaintenanceComponent.prototype.openEditMaintenanceDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editMaintenanceCheckboxDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                _this.loadAllTags();
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "interiorTags", {
        get: function () {
            return this._interiorTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "exteriorTags", {
        get: function () {
            return this._exteriorTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "airframeTags", {
        get: function () {
            return this._airframeTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "airframeManufacturerTags", {
        get: function () {
            return this._airframeManufacturerTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "powerplantTags", {
        get: function () {
            return this._powerplantTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "powerplantManufacturerTags", {
        get: function () {
            return this._powerplantManufacturerTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "propellerTags", {
        get: function () {
            return this._propellerTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "propellerManufacturerTags", {
        get: function () {
            return this._propellerManufacturerTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "avionicsTags", {
        get: function () {
            return this._avionicsTags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessMaintenanceComponent.prototype, "avionicsManufacturerTags", {
        get: function () {
            return this._avionicsManufacturerTags;
        },
        enumerable: true,
        configurable: true
    });
    BusinessMaintenanceComponent.prototype.loadAllTags = function () {
        // Load Interior
        this._interiorTags = loadTags(this.business.tags, 'Maintenance::Interior::', '', '');
        // Load Exterior
        this._exteriorTags = loadTags(this.business.tags, 'Maintenance::Exterior::', '', '');
        // Load Airframe
        this._airframeTags = loadTags(this.business.tags, 'Maintenance::Airframe::', '', 'Maintenance::Airframe::Manufacturers::');
        // Load Airframe Manufacturer
        this._airframeManufacturerTags = loadTags(this.business.tags, 'Maintenance::Airframe::Manufacturers::', '', '');
        // Load Powerplant
        this._powerplantTags = loadTags(this.business.tags, 'Maintenance::Powerplant::', '', 'Maintenance::Powerplant::Manufacturers::');
        // Load Powerplant Manufacturer, but exclude the FAA repair tag.
        this._powerplantManufacturerTags = loadTags(this.business.tags, 'Maintenance::Powerplant::Manufacturers::', '', '')
            .filter(function (tagName) { return !tagName.includes('FAA Repair'); });
        // Load Propeller
        this._propellerTags = loadTags(this.business.tags, 'Maintenance::Propeller::', 'Maintenance::Rotor::', 'Maintenance::Propeller::Manufacturers::');
        // Load Propeller Manufacturer
        this._propellerManufacturerTags = loadTags(this.business.tags, 'Maintenance::Propeller::Manufacturers::', '', '');
        // Load Avionics
        this._avionicsTags = loadTags(this.business.tags, 'Maintenance::Avionics::', '', 'Maintenance::Avionics::Manufacturers::');
        // Load Avionics Manufacturer
        this._avionicsManufacturerTags = loadTags(this.business.tags, 'Maintenance::Avionics::Manufacturers::', '', '');
    };
    return BusinessMaintenanceComponent;
}());
export { BusinessMaintenanceComponent };
